import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderPlus } from 'lucide-react';
import { NewCaseModal } from '../NewCaseModal';

export const ErsteAkteButton = ({ mnr, variante = 'kopf' }) => {
  const navigate = useNavigate();
  const [offen, setOffen] = useState(false);
  const knopf = (
    <button type="button" onClick={() => setOffen(true)} data-testid={`m360-erste-akte-${variante}`}
      className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full text-xs bg-[#b8893d] text-white hover:bg-[#a5782f] shadow-[0_8px_20px_-10px_rgba(184,137,61,0.8)] transition-[background-color,transform] duration-200 hover:-translate-y-px">
      <FolderPlus className="w-3.5 h-3.5" /> Erste Akte anlegen
    </button>
  );
  return (
    <>
      {variante === 'leer' ? (
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 rounded-xl border border-dashed border-[#b8893d]/50 bg-[#fbf7f0] px-5 py-5" data-testid="m360-keine-akte">
          <span className="w-11 h-11 shrink-0 rounded-xl bg-white border border-[#b8893d]/30 flex items-center justify-center"><FolderPlus className="w-5 h-5 text-[#b8893d]" /></span>
          <span className="flex-1">
            <span className="block font-serif text-lg text-[#1B3A5C]">Noch keine Akte</span>
            <span className="block text-xs text-[#34536b]">Der Mandant ist angelegt. Legen Sie die erste Akte mit Rechtsgebiet und Aktenzeichen an, sobald das Mandat beginnt.</span>
          </span>
          {knopf}
        </div>
      ) : knopf}
      {offen && <NewCaseModal mnr={mnr} onClose={() => setOffen(false)} onCreated={(c) => { setOffen(false); navigate(`/team-portal/${c.id}`); }} />}
    </>
  );
};
